<template>
  <div>
    <component
      :is="viewComponent"
      :key="metric.name"
      :metric="metric"
      :account-id="accountId"
      :facebook-page-id="facebookPageId"
    />
  </div>
</template>

<script>
import { DAY } from '@/utils/instagram-insights-query-params';
import MetricChartView from './metric-chart-view.vue';
import MetricTableView from './metric-table-view.vue';
import MetricGenderAgeTableView from './metric-gender-age-table-view.vue';

export default {
  components: {
    MetricChartView,
    MetricTableView,
    MetricGenderAgeTableView,
  },
  props: {
    metric: {
      type: Object,
      required: true,
    },
    accountId: {
      type: String,
      required: true,
    },
    facebookPageId: {
      type: String,
      required: true,
    },
  },
  computed: {
    viewComponent() {
      if (this.metric.name === 'audience_gender_age') {
        return 'MetricGenderAgeTableView';
      }

      return this.metric.periods.indexOf(DAY) >= 0 ? 'MetricChartView' : 'MetricTableView';
    },
  },
};
</script>
